import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MultiSelectFilter from "./MultiSelectFilter/MultiSelectFilter";
import { getFarmsList } from "../../../actions/Farms/farms";

const FarmMultiSelectFilter = ({
  actions: { fetchList },
  list,
  isFetching,
  ...extraProps
}) => {
  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const options = useMemo(
    () =>
      list
        .filter(item => !item.archived)
        .map(item => ({
          key: item.id,
          text: item.name,
          value: item.id
        }))
        .sort((item1, item2) => item1.text.localeCompare(item2.text)),
    [list]
  );

  return (
    <MultiSelectFilter
      options={options}
      numbers={true}
      loading={isFetching}
      {...extraProps}
    />
  );
};

const mapStateToProps = state => {
  const {
    farms: {
      isFetching,
      data: { content }
    }
  } = state;

  return {
    list: content,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchList: getFarmsList
    },
    dispatch
  )
});

FarmMultiSelectFilter.propTypes = {
  isFetching: PropTypes.bool,
  list: PropTypes.array,
  actions: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FarmMultiSelectFilter);
